import React from 'react'

// 首頁的系列橫幅：《系列名》＋副標。原本是無原始檔的 PNG，2026-10-31 改成內嵌 SVG，
// 文字是真的文字，改字直接改 Home.tsx 傳進來的 title／subtitle。
// 座標以原圖 1450×183 量出來，SVG 照寬度等比縮放，版面跟原圖一致。
const W = 1450
const H = 183
const FONT = '"PingFang TC", "Noto Sans TC", "Microsoft JhengHei", sans-serif'

export const SeriesBanner = (props: { title: string, subtitle: string }) => {
    const gradientId = "series-banner-bg"
    return (
        <svg viewBox={`0 0 ${W} ${H}`} width="100%" role="img"
             aria-label={`《${props.title}》${props.subtitle}`}
             style={{display: "block", fontFamily: FONT, fontSynthesis: "none"}}>
            <defs>
                {/* 由左往右的淺灰漸層，取樣自原圖第 40 列 */}
                <linearGradient id={gradientId} x1="0" x2="1" y1="0" y2="0">
                    <stop offset="0" stopColor="#e7e7e7"/>
                    <stop offset="0.07" stopColor="#eaeaea"/>
                    <stop offset="0.34" stopColor="#f5f5f5"/>
                    <stop offset="0.69" stopColor="#f9f9f9"/>
                    <stop offset="0.9" stopColor="#f7f7f7"/>
                    <stop offset="1" stopColor="#f5f5f5"/>
                </linearGradient>
            </defs>
            <rect x="2" y="2" width={W - 4} height={H - 4} rx="4" fill={`url(#${gradientId})`}/>
            {/* 原圖的寫法是「《 標題 》」括號內外各留一個空格 */}
            <text x="69" y="117" fill="#141414" fontSize="72" fontWeight="normal" xmlSpace="preserve">
                {`《 ${props.title} 》`}
                <tspan dx="0" fontSize="48">{props.subtitle}</tspan>
            </text>
        </svg>
    )
}
